module.exports = __webpack_public_path__ + "img/gohr_new.a2958bf6.png";